import { Box, Button, Toolbar } from "@mui/material";
import { Check, FilterAltOutlined } from "@mui/icons-material";
import React, { useContext, useState } from "react";

import AppBar from "@mui/material/AppBar";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import FilterOption from "./FilterOption";
import IconButton from "@mui/material/IconButton";
import LectureListContext from "../../../contexts/LectureListContext";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import Typography from "@mui/material/Typography";
import { selectAllAreas } from "../../../stores/areas/areasSelectors";
import { selectAllInstructors } from "../../../stores/instructors/instructorsSelectors";
import { styled } from "@mui/system";
import { useSelector } from "../../../stores";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FiltersModal = () => {
    const [open, setOpen] = useState(false);

    const instructors = useSelector(selectAllInstructors);
    const areas = useSelector(selectAllAreas);

    const [isInstructorFilterOpen, setIsInstructorFilterOpen] = useState(false);
    const [isAreaFilterOpen, setIsAreaFilterOpen] = useState(false);
    const [isHasVideoFilterOpen, setIsHasVideoFilterOpen] = useState(false);

    const { instructorIds, setInstructorIds, areaIds, setAreaIds, hasVideo, setHasVideo } =
        useContext(LectureListContext);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setIsInstructorFilterOpen(false);
        setIsAreaFilterOpen(false);
        setIsHasVideoFilterOpen(false);
    };

    const renderContent = () => {
        if (isInstructorFilterOpen) {
            return (
                <PageWrapper>
                    <AppBar
                        sx={{
                            position: "relative",
                            width: "100%",
                        }}
                    >
                        <Toolbar
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: 5,
                            }}
                        >
                            <Typography
                                color="#006E94"
                                variant="h5"
                                sx={{ flexGrow: 1, textAlign: "center" }}
                            >
                                اسم المحاضر
                            </Typography>

                            <IconButton
                                onClick={handleClose}
                                edge="start"
                                sx={{ color: "#006E94" }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box
                        display="flex"
                        height="100%"
                        flexDirection="column"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={2}
                        pb={5}
                    >
                        <Box
                            display="flex"
                            height="100%"
                            width="100%"
                            flexDirection="column"
                        >
                            {[...instructors].map((instructor) => (
                                <Box
                                    key={instructor.id}
                                    onClick={() => {
                                        setInstructorIds((prevIds) =>
                                            prevIds.includes(
                                                Number(instructor.id)
                                            )
                                                ? prevIds.filter(
                                                      (id) =>
                                                          id !==
                                                          Number(instructor.id)
                                                  )
                                                : [
                                                      ...prevIds,
                                                      Number(instructor.id),
                                                  ]
                                        );
                                    }}
                                    bgcolor={
                                        instructorIds.includes(
                                            Number(instructor.id)
                                        )
                                            ? "#F1EEDB"
                                            : "transparent"
                                    }
                                    sx={{
                                        padding: 2,
                                        borderBottom: "1px solid #006E94",
                                    }}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography variant="h5">
                                        {instructor.fullName}
                                    </Typography>

                                    {instructorIds.includes(
                                        Number(instructor.id)
                                    ) && <Check />}
                                </Box>
                            ))}

                            <Box
                                paddingY={1}
                                width="100%"
                                display="flex"
                                justifyContent="center"
                                bottom={0}
                                position="absolute"
                                bgcolor="#F1EEDB"
                            >
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "95%",
                                        backgroundColor: "#006E94",
                                        borderRadius: 10,
                                        height: "50px",
                                    }}
                                    onClick={() =>
                                        setIsInstructorFilterOpen(false)
                                    }
                                >
                                    <Typography color="white">اختار</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </PageWrapper>
            );
        } else if (isAreaFilterOpen) {
            return (
                <PageWrapper>
                    <AppBar
                        sx={{
                            position: "relative",
                            width: "100%",
                        }}
                    >
                        <Toolbar
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: 5,
                            }}
                        >
                            <Typography
                                color="#006E94"
                                variant="h5"
                                sx={{ flexGrow: 1, textAlign: "center" }}
                            >
                                اسم المنطقه
                            </Typography>

                            <IconButton
                                onClick={handleClose}
                                edge="start"
                                sx={{ color: "#006E94" }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box
                        display="flex"
                        height="100%"
                        flexDirection="column"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={2}
                        pb={10}
                    >
                        <Box
                            display="flex"
                            height="100%"
                            width="100%"
                            flexDirection="column"
                        >
                            {areas.map((area) => (
                                <Box
                                    key={area.id}
                                    onClick={() => {
                                        setAreaIds((prevIds) =>
                                            prevIds.includes(Number(area.id))
                                                ? prevIds.filter(
                                                      (id) =>
                                                          id !== Number(area.id)
                                                  )
                                                : [...prevIds, Number(area.id)]
                                        );
                                    }}
                                    bgcolor={
                                        areaIds.includes(Number(area.id))
                                            ? "#F1EEDB"
                                            : "transparent"
                                    }
                                    sx={{
                                        padding: 2,
                                        borderBottom: "1px solid #006E94",
                                    }}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography variant="h5">
                                        {area.name}
                                    </Typography>

                                    {areaIds.includes(Number(area.id)) && (
                                        <Check />
                                    )}
                                </Box>
                            ))}

                            <Box
                                paddingY={1}
                                width="100%"
                                display="flex"
                                justifyContent="center"
                            >
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "95%",
                                        backgroundColor: "#006E94",
                                        borderRadius: 10,
                                        height: "50px",
                                    }}
                                    onClick={() => setIsAreaFilterOpen(false)}
                                >
                                    <Typography color="white">اختار</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </PageWrapper>
            );
        } else if (isHasVideoFilterOpen) {
            return (
                <PageWrapper>
                    <AppBar
                        sx={{
                            position: "relative",
                            width: "100%",
                        }}
                    >
                        <Toolbar
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: 5,
                            }}
                        >
                            <Typography
                                color="#006E94"
                                variant="h5"
                                sx={{ flexGrow: 1, textAlign: "center" }}
                            >
                                الفيديو
                            </Typography>

                            <IconButton onClick={handleClose} edge="start" sx={{ color: "#006E94" }}>
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box
                        display="flex"
                        height="100%"
                        flexDirection="column"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={2}
                        pb={5}
                    >
                        <Box display="flex" height="100%" width="100%" flexDirection="column">
                            {[
                                { label: "يوجد فيديو", value: true },
                                { label: "لا يوجد فيديو", value: false },
                            ].map((opt) => (
                                <Box
                                    key={String(opt.value)}
                                    onClick={() => setHasVideo(opt.value)}
                                    bgcolor={hasVideo === opt.value ? "#F1EEDB" : "transparent"}
                                    sx={{ padding: 2, borderBottom: "1px solid #006E94" }}
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Typography variant="h5">{opt.label}</Typography>
                                    {hasVideo === opt.value && <Check />}
                                </Box>
                            ))}

                            <Box
                                paddingY={1}
                                width="100%"
                                display="flex"
                                justifyContent="center"
                                bottom={0}
                                position="absolute"
                                bgcolor="#F1EEDB"
                            >
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "95%",
                                        backgroundColor: "#006E94",
                                        borderRadius: 10,
                                        height: "50px",
                                    }}
                                    onClick={() => setIsHasVideoFilterOpen(false)}
                                >
                                    <Typography color="white">اختار</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </PageWrapper>
            );
        } else {
            return (
                <PageWrapper>
                    <AppBar
                        sx={{
                            position: "relative",
                            width: "100%",
                        }}
                    >
                        <Toolbar
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                paddingTop: 5,
                            }}
                        >
                            <Typography
                                color="#006E94"
                                variant="h5"
                                sx={{
                                    flexGrow: 1,
                                    textAlign: "center",
                                }}
                            >
                                الخيارات
                            </Typography>

                            <IconButton
                                onClick={handleClose}
                                edge="start"
                                sx={{ color: "#006E94" }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box
                        display="flex"
                        height="100%"
                        flexDirection="column"
                        justifyContent="space-between"
                        p={2}
                        gap={2}
                        pb={5}
                    >
                        <Box
                            display="flex"
                            height="100%"
                            flexDirection="column"
                            gap={3}
                            pt={2}
                        >
                            <FilterOption
                                onClick={() => setIsInstructorFilterOpen(true)}
                                title="المحاضر"
                            />

                            <FilterOption onClick={() => setIsAreaFilterOpen(true)} title="المنطقه" />

                            <FilterOption onClick={() => setIsHasVideoFilterOpen(true)} title="الفيديو" />
                        </Box>

                        <Button
                            onClick={() => setOpen(false)}
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: "#006E94",
                                borderRadius: 10,
                                height: "50px",
                            }}
                        >
                            <Typography color="white">تم </Typography>
                        </Button>
                    </Box>
                </PageWrapper>
            );
        }
    };
    return (
        <React.Fragment>
            <Box
                borderRadius="25px"
                height="43px"
                width="43px"
                p={0.1}
                bgcolor="#006E94"
                display="flex"
                justifyContent="center"
                alignItems="center"
                onClick={handleClickOpen}
            >
                <FilterAltOutlined
                    sx={{
                        fontSize: "30px",
                        fontWeight: 300,
                        color: "#F1EEDB",
                    }}
                />
            </Box>

            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                {renderContent()}
            </Dialog>
        </React.Fragment>
    );
};

export default FiltersModal;

const PageWrapper = styled(Box)({
    display: "flex",
    minHeight: "100vh",
    flexDirection: "column",
    backgroundImage: "url(/assets/tawhadi_background.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
    overflow: "scroll",
});
